import React from 'react';

export default class BlankSVG extends React.Component {
	constructor(props) {
		super(props);
		this.state={};
	}
	render () {
		return (
			<svg version="1.1"
				 id="svg_fill"
				 xmlns="http://www.w3.org/2000/svg"
				 x="0px"
				 y="0px"
				 viewBox="0 0 1920 1080"
				 preserveAspectRatio="xMidYMid slice"
			>
				<g>
					<rect x="855.34" y="328.41" transform="matrix(0.7197 -0.6943 0.6943 0.7197 45.3001 1111.025)" className="st0" width="1086.36" height="342"/>
					<rect x="851.72" y="343.44" transform="matrix(0.7197 -0.6943 0.6943 0.7197 33.8521 1112.7196)" className="st0" width="1086.36" height="342"/>
					<rect x="848.09" y="358.46" transform="matrix(0.7197 -0.6943 0.6943 0.7197 22.4041 1114.4141)" className="st0" width="1086.36" height="342"/>
					<rect x="844.47" y="373.49" transform="matrix(0.7197 -0.6943 0.6943 0.7197 10.9561 1116.1086)" className="st0" width="1086.36" height="342"/>
					<rect x="840.84" y="388.51" transform="matrix(0.7197 -0.6943 0.6943 0.7197 -0.4919 1117.8031)" className="st0" width="1086.36" height="342"/>
					<rect x="837.21" y="403.54" transform="matrix(0.7197 -0.6943 0.6943 0.7197 -11.9399 1119.4977)" className="st0" width="1086.36" height="342"/>
				</g>
			</svg>
		)
	}
}

